import { Flex, Stack } from '@mantine/core'
import React, { useCallback, useEffect, useState } from 'react'
import { getOneEmployee } from 'src/apis/employeeAPI'
import CustomeFieldItem from 'src/components/CustomComponents/CustomFieldItem'
import { useLoading } from 'src/context/LoadingContext'
import { convertPermissionValueToLabel, userDataFields } from 'src/variable/constant'
import styles from '../UserDetail/UserDetail.module.scss'
import CustomGoBack from 'src/components/CustomComponents/CustomGoBack'
import { useNavigate } from 'react-router-dom'
const formatFieldValue = (value) => {
	if (value === null || value === undefined || value === '') return '-'
	if (Array.isArray(value)) {
		const items = value
			.map((item) => (typeof item === 'string' ? item : item?.name || ''))
			.filter(Boolean)
		return items.length ? items.join(', ') : '-'
	}
	if (typeof value === 'boolean') return value ? 'Active' : 'Inactive'
	if (typeof value === 'object') return value?.name || '-'
	return value
}

function EmployeeDetail({
	id,
	fields = userDataFields,
	label = 'Employee',
	goBack = '/employees',
}) {
	const navigate = useNavigate()
	const [data, setData] = useState<any>()
	const { openLoadingContext, closeLoadingContext } = useLoading()
	const handleGetData = useCallback(async () => {
		openLoadingContext()
		try {
			const res = await getOneEmployee(id, { fields: ['$all', '$paranoid'] })
			if (res?.data?.code === 200) {

				const {employee_roles, ...rest} = res?.data?.results?.object
				const employee_roles_mapped = employee_roles.map((role: any) => convertPermissionValueToLabel(role.name))

				const detail = {
					employee_roles: employee_roles_mapped,
					...rest
				}
				setData(detail)
			}
		} catch (error) {
			console.log(
				'🧑‍🏭 TrieuNinhHan ~ file: UserDetail.tsx:9 ~ handleGetData ~ error:',
				error,
			)
		} finally {
			closeLoadingContext()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])
	useEffect(() => {
		handleGetData()
	}, [handleGetData])
	return (
		<Stack sx={{ width: '100%' }}>
			<CustomGoBack
				label={label}
				onClick={() => {
					navigate(goBack)
				}}
			/>
			<Flex className={styles.containerFields}>
				{/* <Avatar src={data?.avatar} size={160} radius={'50%'} /> */}
				<Flex sx={{ flexWrap: 'wrap' }}>
					<Flex sx={{ flexWrap: 'wrap' }}>
						{fields.map((field) => (
							<CustomeFieldItem
								field={field}
								value={formatFieldValue(data?.[field.value])}
								key={field.value}
							/>
						))}
					</Flex>
				</Flex>
			</Flex>
		</Stack>
	)
}

export default React.memo(EmployeeDetail)
